import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Slide, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from '../../pages/LoginPage/LoginPage';
import NotFoundPage from '../../pages/NotFoundPage/NotFoundPage';
import ProfilePage from '../../pages/ProfilePage/ProfilePage';
import SettingsPage from '../../pages/SettingsPage/SettingsPage';
import SignUp from '../../pages/SignUp/SignUp';

import { CurrentUserContext } from '../../contexts/CurrentUserContext';
import { MessageProvider } from '../../contexts/MessageContext';
import { SettingsProvider } from '../../contexts/SettingsContext';
import MainPage from '../../pages/MainPage/MainPage';
import apiAuth from '../../utils/ApiAuth';
import apiUser from '../../utils/ApiUser';
import ProtectedRoute from '../../utils/ProtectedRoute';
import Preloader from '../Preloader/Preloader';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    apiUser
      .getUserInfo()
      .then((userInfo) => {
        setCurrentUser({
          name: userInfo.name,
          email: userInfo.email,
          _id: userInfo._id,
        });
        setIsLoggedIn(true);
      })
      .catch((err) => {
        console.error(`Ошибка получения данных: ${err}`);
        setIsLoggedIn(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function handleLogin({email, password}) {
    apiAuth
      .login(email, password)
      .then((res) => {
        if (res) {
          setIsLoggedIn(true);
          apiUser.getUserInfo().then((res) => {
            setCurrentUser({
              name: res.name,
              email: res.email,
              _id: res._id,
            });
          });

          toast.success('Успешная авторизация!');
          setTimeout(() => {
            navigate('/');
          }, 1000);
        }
      })
      .catch((err) => {
        console.error(`Ошибка авторизации: ${err}`);
        toast.error('Ошибка авторизации');
      });
  }

  function handleRegister({name, email, password, confirmPassword}) {
     /*  apiAuth
      .register(name, email, password)
      .then((res) => {
        if (res) {
          setIsLoggedIn(true);
          setCurrentUser({
            name: res.name,
            email: res.email,
            _id: res._id,
          });
          
          toast.success('Успешная регистрация!');
          setTimeout(() => {
            navigate('/');
          }, 1000);
        }
      })
      .catch((err) => {
        console.error(`Ошибка регистрации: ${err}`);
        toast.error('Ошибка регистрации');
      }); */
    toast.error('На данный момент регистрация не доступна');
  }

  function handleLogoutUser() {
    apiUser
      .logoutUser()
      .then((res) => {
        localStorage.clear();
        sessionStorage.clear();
        setCurrentUser({name: '', email: '', _id: ''});
        setIsLoggedIn(false);
        navigate('/');
      })
      .catch((err) => {
        console.error(`Ошибка выхода: ${err}`);
        toast.error('Ошибка выхода');
      });
  }

  function handleUpdateUser(userData) {
    apiUser
      .editUserInfo(userData)
      .then((res) => {
        setCurrentUser(res);
        toast.success('Данные пользователя успешно обновлены!');
      })
      .catch((err) => {
        console.error(`Ошибка обновления данных профиля: ${err}`);
        toast.error('Ошибка обновления данных профиля');
      });
  }

  function handleDeleteUser() {
    apiUser
      .deleteUser()
      .then((res) => {
        toast.success(res.message || 'Пользователь успешно удален');
        localStorage.clear();
        setCurrentUser({});
        setIsLoggedIn(false);
        navigate('/signup');
      })
      .catch((err) => {
        console.error(`Ошибка удаления пользователя: ${err}`);
        toast.error('Ошибка при удалении пользователя');
      });
  }

  return (
    <>
      {loading ? (
        <Preloader onLoaded={() => setLoading(false)} />
      ) : (
        <CurrentUserContext.Provider value={currentUser}>
          <SettingsProvider>
            {/* fix: разделить провайдеры по роутам*/}
            <MessageProvider>
              <Routes>
                <Route path='/signin' element={<Login isLoggedIn={isLoggedIn} handleLogin={handleLogin} />} />
                <Route path='/signup' element={<SignUp isLoggedIn={isLoggedIn} handleRegister={handleRegister} />} />
                <Route path='*' element={<NotFoundPage />} />

                <Route path='/' element={<ProtectedRoute element={MainPage} isLoggedIn={isLoggedIn} loading={loading} />} />
                <Route
                  path='/profile'
                  element={
                    <ProtectedRoute
                      element={ProfilePage}
                      isLoggedIn={isLoggedIn}
                      loading={loading}
                      handleLogoutUser={handleLogoutUser}
                      handleUpdateUser={handleUpdateUser}
                      handleDeleteUser={handleDeleteUser}
                    />
                  }
                />
                <Route path='/settings' element={<ProtectedRoute element={SettingsPage} isLoggedIn={isLoggedIn} loading={loading} />} />
              </Routes>
              <ToastContainer
                position='top-center'
                autoClose={2500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                theme='light'
                transition={Slide}
              />
            </MessageProvider>
          </SettingsProvider>
        </CurrentUserContext.Provider>
      )}
    </>
  );
}

export default App;
